import type { ChatMessage, OutputBroadcast } from './types'

// A live 'user' broadcast as a transcript turn, carrying the inter-agent
// sender/source when the turn was delivered by another agent (#1837).
export function userTurnFromBroadcast(data: OutputBroadcast): ChatMessage {
  const turn: ChatMessage = { role: 'you', text: data.output, created_at: new Date().toISOString() }
  if (data.sender_name) {
    turn.sender_name = data.sender_name
    turn.source = data.source ?? null
  }
  return turn
}
